import "./BookingCalendarHeader.scss";
import arrowRight from "../../../../assets/images/icons/arrow-right.svg";
import {DatePicker, DatePickerProps} from "antd";
import React, {Dispatch, SetStateAction} from "react";
import moment, {Moment} from "moment";
import dayjs from "dayjs";
import {monthAndDay} from "../AccountBooking";
import {useTranslation} from "react-i18next";


interface IBookingCalendarHeaderProps {
    setToday: Dispatch<SetStateAction<moment.Moment>>
    startDay: Moment
    viewCalendar: monthAndDay
    setViewCalendar: (value: monthAndDay) => void
    today: Moment
}


const BookingCalendarHeader: React.FC<IBookingCalendarHeaderProps> = ({
                                                                          setToday,
                                                                          startDay,
                                                                          viewCalendar,
                                                                          setViewCalendar,
                                                                          today
                                                                      }) => {

    const {t} = useTranslation();


    const datePickerChange: DatePickerProps['onChange'] = (date, dateString) => {
        setToday(moment(dateString));
    }

    const viewCalendarDate: { label: string, value: monthAndDay }[] = [
        {
            label: "Day",
            value: "day"
        }, {
            label: "Month",
            value: "month"
        }
    ];

    const prev = () => {
        if (viewCalendar === "month") {
            setToday(prev => prev.clone().subtract(1, "month"));
        }

        if (viewCalendar === "day") {
            setToday(prev => prev.clone().subtract(1, "day"));
        }
    }

    const next = () => {
        if (viewCalendar === "month") {
            setToday(prev => prev.clone().add(1, "month"));
        }
        if (viewCalendar === "day") {
            setToday(prev => prev.clone().add(1, "day"));
        }

    }

    const changeViewCalendar = (value: monthAndDay) => {
        setViewCalendar(value);
    }

    return (
        <div className="container">
            <div className="booking-calendar-header">
                <div className="wrapper">
                    <h2 className="title">{t("Bookings")}</h2>
                    <div className="date-picker-box">
                        <button onClick={prev} className="date-picker-btn left">
                            <img src={arrowRight} alt={"left"}/>
                        </button>
                        <DatePicker
                            className="date-picker"
                            bordered={false}
                            format={viewCalendar === "month" ? "MMMM YYYY" : "DD MMM YYYY"}
                            onChange={datePickerChange}
                            picker={viewCalendar === "month" ? "month" : "date"}
                            clearIcon={false}
                            suffixIcon={false}
                            value={viewCalendar === "month" ? dayjs(moment(startDay.clone()).add(2, "weeks").toString()) : dayjs(moment(today.clone()).toString())}
                        />
                        <button onClick={next} className="date-picker-btn">
                            <img src={arrowRight} alt={"right"}/>
                        </button>
                    </div>
                </div>
                <div className="btns-wrapper">
                    {
                        viewCalendarDate.map(el => {
                            return (
                                <button
                                    key={el.value}
                                    onClick={() => {
                                        changeViewCalendar(el.value)
                                    }}
                                    className={`btn ${el.value === viewCalendar && 'active'}`}
                                >
                                    {el.label}
                                </button>
                            )
                        })
                    }
                </div>

            </div>
        </div>
    )
}

export default BookingCalendarHeader;